// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38ymm","largestCol":"styles_largestCol__3dHFa","smallestCol":"styles_smallestCol__2tQZL"};